class QuickAddDrawerController {
  constructor() {
    this.root = document.querySelector('[data-quick-add-drawer]');
    if (!this.root) return;

    this.panel = this.root.querySelector('.quick-add-drawer__panel');
    this.body = this.root.querySelector('[data-quick-add-body]');
    this.lastActiveElement = null;
    this.productController = null;

    this.bindTriggers();
    this.bindClose();
  }

  bindTriggers() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-quick-shop]');
      if (!trigger) return;
      event.preventDefault();
      this.lastActiveElement = trigger;
      this.openForUrl(trigger.getAttribute('data-quick-shop'));
    });
  }

  bindClose() {
    this.root.querySelectorAll('[data-quick-add-close]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.root.classList.contains('is-open')) {
        this.close();
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!this.body.contains(form)) return;
      if (!form.matches('[data-product-form]')) return;
      this.close();
    });
  }

  async openForUrl(url) {
    if (!url) return;
    this.open();
    this.body.innerHTML = '<div class="quick-add-drawer__loading">Loading…</div>';

    try {
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Failed to load product');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sectionRoot = doc.querySelector('[data-product-section]');
      if (!sectionRoot) throw new Error('Product section not found');

      this.body.innerHTML = '';
      this.body.appendChild(sectionRoot);

      if (typeof window.ProductSectionController !== 'undefined') {
        this.productController = new window.ProductSectionController(sectionRoot);
      }

      if (typeof window.initDropdownPickers !== 'undefined') {
        window.initDropdownPickers(sectionRoot);
      }
    } catch (error) {
      console.error(error);
      this.body.innerHTML = '<div class="quick-add-drawer__loading">Something went wrong.</div>';
    }
  }

  open() {
    this.root.classList.add('is-open');
    this.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('quick-add-drawer-open');
  }

  close() {
    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('quick-add-drawer-open');
    this.lastActiveElement?.focus();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new QuickAddDrawerController();
});
